module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "non"
  }, [_c('span', {
    staticClass: "ss"
  }, [_vm._v("Dedication")]), _vm._v(" I dedicate this book to my son, Brady, lover of all things mystical and magical. His favorite movies involve fantasy creatures. He is my inspiration and my biggest fan.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box2"
  }, [_c('p', {
    staticClass: "non",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    staticClass: "ss"
  }, [_vm._v("Acknowledgments")]), _vm._v(" A special thank you to my daughter, Jesi. She is a loyal supporter and my right-hand gal. She accompanies me to my many lectures and vending gigs. I would be lost without her super organizational skills.")])]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg4_1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37a7ffd8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_dedicationtitle.vue
// module id = 63
// module chunks = 0